/**
 * <s-gallery-thumbs> — links a product gallery's thumbnail buttons to its scrolling track.
 *   [data-gallery-track]  horizontally scrolling list of slides ([data-gallery-slide]).
 *   [data-gallery-thumb="n"]  button that shows slide n; gets aria-current="true" while active.
 */
class SGalleryThumbs extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gallery-track]');
    this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    if (!this.track || this.thumbs.length === 0) return;
    this.slides = [...this.track.querySelectorAll('[data-gallery-slide]')];

    this.onClick = (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      const slide = this.slides[Number(thumb.dataset.galleryThumb)];
      if (!slide) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      this.setActive(Number(thumb.dataset.galleryThumb));
    };
    this.addEventListener('click', this.onClick);

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
        }
      },
      { root: this.track, threshold: 0.6 }
    );
    this.slides.forEach((slide) => this.observer.observe(slide));
  }

  setActive(index) {
    this.thumbs.forEach((thumb, i) => {
      if (i === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-gallery-thumbs')) customElements.define('s-gallery-thumbs', SGalleryThumbs);
